import * as React from "react";
const SvgFiRrBadgePercent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-badge-percent_svg__a)">
      <path
        fill="#062147"
        d="M12 24a5.49 5.49 0 0 1-4.208-1.959c-1.54.177-3.127-.406-4.277-1.555a5.5 5.5 0 0 1-1.59-4.362C.714 15.16 0 13.626 0 12s.714-3.16 1.96-4.208c-.175-1.537.405-3.127 1.555-4.277a5.48 5.48 0 0 1 4.361-1.59C8.84.715 10.374 0 12 0a5.49 5.49 0 0 1 4.208 1.959c1.542-.176 3.127.406 4.277 1.555a5.5 5.5 0 0 1 1.59 4.362C23.286 8.84 24 10.374 24 12s-.714 3.16-1.96 4.208c.175 1.537-.405 3.127-1.555 4.277a5.5 5.5 0 0 1-4.361 1.59C15.16 23.285 13.626 24 12 24m-4.127-3.924c.561 0 1.081.241 1.448.676A3.5 3.5 0 0 0 12 22a3.5 3.5 0 0 0 2.679-1.248c.403-.479.99-.721 1.616-.67a3.498 3.498 0 0 0 3.788-3.788 1.88 1.88 0 0 1 .67-1.617 3.496 3.496 0 0 0 0-5.356 1.88 1.88 0 0 1-.67-1.617 3.5 3.5 0 0 0-1.012-2.776 3.52 3.52 0 0 0-2.775-1.012 1.87 1.87 0 0 1-1.617-.669A3.5 3.5 0 0 0 12 1.999a3.5 3.5 0 0 0-2.679 1.248 1.89 1.89 0 0 1-1.616.67 3.48 3.48 0 0 0-2.776 1.012 3.5 3.5 0 0 0-1.012 2.776 1.88 1.88 0 0 1-.67 1.617 3.496 3.496 0 0 0 0 5.356c.479.403.724.993.67 1.617a3.5 3.5 0 0 0 1.012 2.776 3.51 3.51 0 0 0 2.775 1.012q.085-.007.169-.007M9 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4.168 1.555 4-6a1 1 0 1 0-1.664-1.11l-4 6a1 1 0 1 0 1.664 1.11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-badge-percent_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBadgePercent;
